import { render, staticRenderFns } from "./MrpaEnableAssigneePerson.vue?vue&type=template&id=13bcf588&"
import script from "./MrpaEnableAssigneePerson.vue?vue&type=script&lang=js&"
export * from "./MrpaEnableAssigneePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports